import {call, put, takeLatest} from 'redux-saga/effects'
import {alertError, alertSuccess} from '@src/app/services/helper'
import {IBreadProgram, Schedule, Note} from '../models/BreadProgramModel'
import {
  addNewBreadBrogramAction,
  deleteBreadProgramAction,
  EBreadProgramType,
  editBreadProgramAction,
  getItemBreadProgramAction,
  getListBreadProgramAction,
  getListNoteAction,
  getListNoteActionSuccess,
  getScheduleAction,
  getScheduleSuccesAction,
  saveListBreadProgramAction,
  setListBreadProgramLoadingAction,
  setScheduleLoadingAction,
  createScheduleAction,
  deleteScheduleAction,
  createNoteAction,
  deleteNoteAction,
} from './ManagaBreadProgramActions'
import {
  apiGetListBreadProgram,
  apiGetItemBreadProgram,
  apiAddBreadProgram,
  apiUpdateItemBreadProgram,
  apiDeleteBreadProgram,
  apiGetScheduleBeneficiary,
  apiCreateScheduleBeneficiary,
  apiDeleteSchedule,
  apiGetListNoteBreadPrograms,
  apiAddNoteBreadPrograms,
  apiDeleteNoteBreadPrograms,
} from '@src/app/services/api/breadProgramApi'
import {IListResult} from '@src/app/common/CommonModel'

// ================= BREAD_PROGRAM SAGA ====================== //
function* getListBreadProgram() {
  try {
    yield put(setListBreadProgramLoadingAction(true))
    const res: IListResult = yield call(apiGetListBreadProgram)
    if (res) {
      yield put(saveListBreadProgramAction(res.data))
    }
  } catch (error) {
    yield put(setListBreadProgramLoadingAction(false))
  }
}

function* getItemBreadProgram({payload}: ReturnType<typeof getItemBreadProgramAction>) {
  try {
    const res: IBreadProgram = yield call(apiGetItemBreadProgram, payload)
    if (res) {
      // Handle success
    }
  } catch (error: any) {
    alertError(error?.response?.data?.message || 'Error getting bread program')
  }
}

function* addNewBreadProgram({payload}: ReturnType<typeof addNewBreadBrogramAction>) {
  try {
    const res: IBreadProgram = yield call(apiAddBreadProgram, payload.value)
    if (res) {
      alertSuccess('Add bread program successfully!')
      payload.onSuccess()
    }
  } catch (error: any) {
    alertError(error?.response?.data?.message || 'Error adding bread program')
    payload.onError()
  }
}

function* editBreadProgram({payload}: ReturnType<typeof editBreadProgramAction>) {
  try {
    const res: IBreadProgram = yield call(apiUpdateItemBreadProgram, payload.value)
    if (res) {
      alertSuccess('Edit bread program successfully!')
      payload.onSuccess()
    }
  } catch (error: any) {
    alertError(error?.response?.data?.message || 'Error editing bread program')
    payload.onError()
  }
}

function* deleteBreadProgram({payload}: ReturnType<typeof deleteBreadProgramAction>) {
  try {
    const res: IBreadProgram = yield call(apiDeleteBreadProgram, payload.id)
    if (res) {
      alertSuccess('Delete bread program successfully!')
      payload.onSuccess()
    }
  } catch (error: any) {
    alertError(error?.response?.data?.message || 'Error deleting bread program')
    payload.onError()
  }
}

function* getSchedule({payload}: ReturnType<typeof getScheduleAction>) {
  try {
    yield put(setScheduleLoadingAction(true))
    const res: Schedule[] = yield call(apiGetScheduleBeneficiary, payload.beneficiaryId)
    yield put(getScheduleSuccesAction(res))
  } catch (error: any) {
    yield put(setScheduleLoadingAction(false))
  }
}

function* createSchedule({payload}: ReturnType<typeof createScheduleAction>) {
  try {
    const res: Schedule = yield call(apiCreateScheduleBeneficiary, payload.item)
    if (res) {
      alertSuccess('Create schedule successfully!')
      payload.onSuccess()
    }
  } catch (error: any) {
    alertError(error?.response?.data?.message || 'Error creating schedule')
    payload.onError()
  }
}

function* deleteSchedule({payload}: ReturnType<typeof deleteScheduleAction>) {
  try {
    const res: Schedule = yield call(apiDeleteSchedule, payload.id)
    if (res) {
      alertSuccess('Delete schedule successfully!')
      payload.onSuccess()
    }
  } catch (error: any) {
    alertError(error?.response?.data?.message || 'Error deleting schedule')
    payload.onError()
  }
}

function* getListNote({payload}: ReturnType<typeof getListNoteAction>) {
  try {
    const res: Note[] = yield call(apiGetListNoteBreadPrograms, payload.id)
    if (res) {
      yield put(getListNoteActionSuccess(res))
    }
  } catch (error: any) {
    alertError(error?.response?.data?.message || 'Error getting notes')
  }
}

function* createNote({payload}: ReturnType<typeof createNoteAction>) {
  try {
    const res: Note = yield call(apiAddNoteBreadPrograms, payload.noteItem)
    if (res) {
      alertSuccess('Add note successfully!')
      payload.onSuccess()
    }
  } catch (error: any) {
    alertError(error?.response?.data?.message || 'Error adding note')
    payload.onError()
  }
}

function* deleteNote({payload}: ReturnType<typeof deleteNoteAction>) {
  try {
    const res: Note = yield call(apiDeleteNoteBreadPrograms, payload.id)
    if (res) {
      alertSuccess('Delete note successfully!')
      payload.onSuccess()
    }
  } catch (error: any) {
    alertError(error?.response?.data?.message || 'Error deleting note')
    payload.onError()
  }
}

export default function* ManageBreadProgramSaga() {
  yield takeLatest(EBreadProgramType.GET_LIST_BREAD_PROGRAM, getListBreadProgram)
  yield takeLatest(EBreadProgramType.GET_ITEM_BREAD_PROGRAM, getItemBreadProgram)
  yield takeLatest(EBreadProgramType.ADD_NEW_BREAD_PROGRAM, addNewBreadProgram)
  yield takeLatest(EBreadProgramType.EDIT_BREAD_PROGRAM, editBreadProgram)
  yield takeLatest(EBreadProgramType.DELETE_ITEM_BREAD_PROGRAM, deleteBreadProgram)
  yield takeLatest(EBreadProgramType.GET_SCHEDULE_BENEFICIARY, getSchedule)
  yield takeLatest(EBreadProgramType.CREATE_SCHEDULE, createSchedule)
  yield takeLatest(EBreadProgramType.DELETE_SCHEDULE, deleteSchedule)
  yield takeLatest(EBreadProgramType.GET_LIST_NOTE, getListNote)
  yield takeLatest(EBreadProgramType.CREATE_NOTE, createNote)
  yield takeLatest(EBreadProgramType.DELETE_NOTE, deleteNote)
}
